<template>

  <div class="home columns">
    <div class="column is-one-third">
      <point-selector v-on:toggleOverview="toggleOverview()" :trackerId="trackerId" :pointCell="pointCell" v-on:setPoint="getAndSetPoint" />
      <loading-overlay v-if="loading || errorMessage" v-on:retry="getAndSetPoint('latest')" :errorMessage="errorMessage" />
      <point-overview v-else-if="showOverview" :pointCell="pointCell" />
    </div>
    <div class="column is-two-thirds">
      <loading-overlay v-if="loading || errorMessage" v-on:retry="getAndSetPoint('latest')" :errorMessage="errorMessage" />
      <map-view v-else-if="pointCell.point" :point="pointCell.point"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import pointSelector from '@/components/pointSelector.vue'
import pointOverview from '@/components/pointOverview.vue'
import mapView from '@/components/mapView.vue'
import loadingOverlay from '@/components/loadingOverlay.vue'

export default {
  name: 'home',
  components: {
    'point-selector': pointSelector,
    'point-overview': pointOverview,
    'map-view': mapView,
    'loading-overlay': loadingOverlay
  },
  data: () => {
    return {
      loading: true,
      errorMessage: null,
      pointCell: null,
      showOverview: true,
      trackerId: null
    }
  },
  methods: {
    async getAndSetPoint ({ index, trackerId }) {
      this.loading = true
      this.errorMessage = null
      // Fetch point from store/server
      const [error, pointCell] = await this.$store.dispatch('getPoint', { index, trackerId })
      this.loading = false
      if (error) this.errorMessage = error
      else this.pointCell = pointCell
    },
    toggleOverview () {
      this.showOverview = !this.showOverview
    }
  },
  async created () {
    if (!await this.$store.dispatch('checkAuthToken')) return this.$router.push('/login')
  }
}
</script>

<style scoped>
.column {
  padding: 0;
}
.columns {
  margin-top: 0;
}
</style>
